import { Transition, FunctionalComponent } from 'vue'
import { RouterView } from 'vue-router'
export * from './routes'

const CustomRouterView = () => {
  return (
    <RouterView
      v-slots={{
        default: ({ Component, route }: { Component: FunctionalComponent; route: any }) => {
          if (!Component) {
            return null
          }
          return (
            <div>
              <Transition duration={550} name={route.meta.transition || 'nested'}>
                <Component key={route.path} />
              </Transition>
            </div>
          )
        },
      }}
    />
  )
}

export default CustomRouterView
